import React from 'react';
import { AcademySection } from '../types';
import { ChevronDown } from 'lucide-react';

interface InfoAccordionProps {
    visible: boolean;
    academySections: AcademySection[];
}

const InfoAccordion: React.FC<InfoAccordionProps> = ({
    visible,
    academySections,
}) => {
    if (!visible) return null;
    return (
        <div className="py-4 sm:py-8 px-0 sm:px-2 w-full max-w-full">
            <h3 className="text-xl sm:text-3xl font-bold text-white mb-2 sm:mb-4">
                FB VİZYON 2035 Akademisi
            </h3>
            <div className="space-y-2 sm:space-y-4">
                {academySections.map((sec, i) => (
                    <details
                        key={i}
                        className="group bg-slate-800 rounded-2xl overflow-hidden shadow-lg"
                    >
                        <summary className="flex justify-between items-center p-2 sm:p-4 cursor-pointer hover:bg-slate-700 transition">
                            <span className="font-semibold text-base sm:text-lg text-white">
                                {sec.title}
                            </span>
                            <ChevronDown className="w-4 h-4 sm:w-5 sm:h-5 text-yellow-400" />
                        </summary>
                        <ul className="px-3 sm:px-6 pb-2 sm:pb-4 text-slate-300 list-inside list-disc space-y-1 sm:space-y-2">
                            {sec.items.map((item, j) => (
                                <li key={j}>{item}</li>
                            ))}
                        </ul>
                    </details>
                ))}
            </div>
        </div>
    );
};

export default InfoAccordion; 